import React from 'react';

const UploadCloud = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3825 6.04265C18.5719 1.97551 14.6177 -0.66432 10.5506 0.146288C7.57584 0.739183 5.24985 3.06371 4.65513 6.03807C1.7714 6.37041 -0.297143 8.97746 0.0350106 11.8614C0.340797 14.5155 2.58878 16.5179 5.26047 16.5161H9.01487C9.4296 16.5161 9.76578 16.1799 9.76578 15.7652C9.76578 15.3505 9.4296 15.0143 9.01487 15.0143H5.26047C3.1868 15.002 1.51597 13.3112 1.52805 11.2377C1.54032 9.16423 3.23112 7.49321 5.30479 7.5053C5.68748 7.50548 6.00901 7.21745 6.05112 6.83714C6.43235 3.54143 9.41312 1.17882 12.7088 1.56004C15.4796 1.88066 17.6653 4.06621 17.9858 6.83714C18.0487 7.22423 18.3842 7.50786 18.7764 7.5053C20.8501 7.5053 22.531 9.1862 22.531 11.2599C22.531 13.3334 20.8501 15.0143 18.7764 15.0143H15.022C14.6073 15.0143 14.2711 15.3505 14.2711 15.7652C14.2711 16.1799 14.6073 16.5161 15.022 16.5161H18.7766C21.6794 16.498 24.018 14.1302 24 11.2273C23.9836 8.58379 22.0064 6.36382 19.3825 6.04265Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M14.6726 13.4754C14.9608 13.7739 15.4361 13.7821 15.7344 13.4939C16.0327 13.2059 16.0409 12.7306 15.7529 12.4323C15.7469 12.4259 15.7406 12.4198 15.7344 12.4138L12.5498 9.22848C12.2571 8.93478 11.7815 8.93423 11.4878 9.22701C11.4875 9.22756 11.4869 9.22793 11.4865 9.22848L8.30198 12.4138C8.0037 12.7018 7.99546 13.1771 8.28349 13.4754C8.57169 13.7737 9.04704 13.7819 9.34531 13.4939C9.35154 13.4879 9.35777 13.4817 9.36381 13.4754L11.2674 11.5711V21.0219C11.2674 21.4367 11.6036 21.7729 12.0183 21.7729C12.4328 21.7729 12.769 21.4367 12.769 21.0219V11.5711L14.6726 13.4754Z"
      fill="var(--SECONDARY_DARK)"
    />
  </svg>
);

export default UploadCloud;
